// extracted by mini-css-extract-plugin
export var boxItems = "_9d-1";
export var boxItemsLg = "_9d-2";
export var button = "_9d-7";
export var buttonHoverless = "_9d-9";
export var buttonLg = "_9d-8";
export var filterGroupBox = "_9d-0";
export var icon = "_9d-3";
export var iconSecondary = "_9d-6";
export var iconWrapper = "_9d-4";
export var iconWrapperLg = "_9d-5";
export var truncatedLabel = "_9d-a";